<template>
  <v-container fluid>
    <ActionBar
      @change="updatePage"
      @exceptionList="openExceptionListDialog"
    />

    <div
      :class="[`${
        isFailed || !items.length
          ? 'page__content--no-items'
          : 'page__content'
      }`, {
        'page__content--from-v4': noMainMenuFromV4
      }]"
    >
      <Table
        :items="items"
        :pagination="pagination"
        :status="currentStatus"
        @reloadData="reloadData"
        @goToPage="updatePage"
        @deleteItem="openDeleteUsagePolicyDialog"
      />
    </div>

    <ExceptionListDialog
      :visible="exceptionListDialog"
      @close="closeExceptionListDialog"
    />

    <DeleteSingleDialog
      :visible="deleteSingleDialog"
      :timePolicy="selectedItem"
      @update="reloadData"
      @close="closeDeleteUsagePolicyDialog"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { isObject } from 'utils/functions'
import ActionBar from 'components/usagePolicies/ActionBar'
import Table from 'components/usagePolicies/Table'
import ExceptionListDialog from 'components/usagePolicies/dialogs/ExceptionListDialog'
import DeleteSingleDialog from 'components/usagePolicies/dialogs/DeleteSingleDialog'

export default {
  name: 'UsagePoliciesPage',
  components: {
    ActionBar,
    Table,
    ExceptionListDialog,
    DeleteSingleDialog
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen,
      selectedCompany: ({ company }) => company.selectedCompany,
      claims: ({ userClaims }) => userClaims.claims,
      noMainMenuFromV4: ({ mainMenu }) => mainMenu.noMainMenuFromV4
    }),

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      namespace: 'Views.UsagePoliciesPage',
      pagination: {
        totalElements: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 25
      },
      filters: {
        search: null
      },
      currentStatus: null,
      items: [],
      selectedItem: null,
      exceptionListDialog: false,
      deleteSingleDialog: false
    }
  },

  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    isValidObject (val) {
      return isObject(val)
    },

    openExceptionListDialog () {
      this.exceptionListDialog = true
    },

    closeExceptionListDialog () {
      this.exceptionListDialog = false
    },

    openEditItemDialog (item) {
      this.selectedItem = item
    },

    openDeleteUsagePolicyDialog (item) {
      this.deleteSingleDialog = true
      this.selectedItem = item
    },

    closeDeleteUsagePolicyDialog (val) {
      this.deleteSingleDialog = false
      this.selectedItem = null
    },

    updatePagination (response, itemsPerPage) {
      const totalPagesCalc = Math.ceil(response.length / itemsPerPage)
      const totalPages = totalPagesCalc > 0 ? totalPagesCalc : 1

      this.pagination = {
        ...this.pagination,
        totalElements: response.length,
        totalPages
      }
    },

    resetPagination () {
      this.pagination = {
        totalElements: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 25
      }
    },

    updateFilters (filters) {
      this.filters = { ...filters }
      this.reloadData()
    },

    updatePage (page) {
      scrollTo(0, 0)

      this.pagination = {
        ...this.pagination,
        currentPage: page
      }

      this.loadData()
    },

    async loadData () {
      this.currentStatus = STATUS_IS_LOADING

      try {
        const { currentPage, itemsPerPage } = this.pagination
        const company = this.selectedCompany ? this.selectedCompany.id : null
        const { data: res } = await this.$apiService.getTimePolicy(
          { page: currentPage },
          { limit: itemsPerPage },
          { company }
        )

        this.items = res.data
        this.updatePagination(res, itemsPerPage)
        this.currentStatus = STATUS_SUCCESS
      } catch (err) {
        console.log('ERROR:', err)
        this.currentStatus = STATUS_FAILED
      }
    },

    reloadData () {
      this.resetPagination()
      this.loadData()
    }
  },

  watch: {
    selectedCompany () {
      this.loadData()
    }
  },

  mounted () {
    this.loadData()
  }
}
</script>
